//
//
//
//
//
//
//
//
//

export default {
  name: 'noComponent',
  methods: {
    goHome () {
      // 进入未报告列表页面
      this.$router.push({name: 'HomePage'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/base/error/noComponent.vue